import React from "react";
import { motion, AnimatePresence } from "framer-motion";
import pass from "./pass.png";
import fail from "./fail.png";

const ConfirmationCard = ({ modal, setModal }) => {
  const closeModal = () => setModal({ ...modal, show: false });

  const status = modal.success
    ? {
        color: "#0A9A3E", 
        title: "Email was successfully sent!",
        button: "OK",
        icon: pass,
      }
    : {
        color: "#D7263D",
        title: "Failed to Send Email!",
        button: "Close",
        icon: fail,
      };

  return (
    <AnimatePresence>
      {modal.show && (
        <motion.div
          className="d-flex justify-content-center align-items-center"
          style={{
            position: "fixed",
            inset: 0,
            background: "rgba(0,0,0,0.55)",
            zIndex: 2000,
          }}
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
        >
          <motion.div
            className="rounded shadow-lg bg-white text-center p-4"
            style={{
              width: "90%",
              maxWidth: "450px",
              borderTop: `8px solid ${status.color}`,
            }}
            initial={{ scale: 0.8, opacity: 0 }}
            animate={{ scale: 1, opacity: 1 }}
            exit={{ scale: 0.8, opacity: 0 }}
            transition={{ duration: 0.35 }}
          >
            {/* ✅/❌ ICON */}
            <img
              src={status.icon}
              alt="status-icon"
              style={{ height: "60px" }}
            />

            {/* Title */}
            <p className="mt-3 mb-4 fs-5 text-dark fw-semibold">
              {status.title}
            </p>

            {/* Close Button */}
            <button
              className="btn text-white px-4 fw-semibold rounded-1"
              style={{
                background: status.color,
              }}
              onClick={closeModal}
            >
              {status.button}
            </button>
          </motion.div>
        </motion.div>
      )}
    </AnimatePresence>
  );
};

export default ConfirmationCard;
